import { useStore } from "@nanostores/preact";
import { useState } from "preact/hooks";
import { $compass, $compassLoaded, $compassSaving, MAX_MARKS, nextMarkName, removeMark, saveCompass, setHidden } from "../state/compass";
import { $playerPos } from "../state/stores";
import { AddMarkForm } from "./AddMarkForm";

/** Pause-menu block: built-in marker switches, my marks with distance and delete, and "mark here" (spec 2e §2.4). */
export function CompassSection() {
  const doc = useStore($compass);
  const loaded = useStore($compassLoaded);
  const saving = useStore($compassSaving);
  const editable = loaded && !saving; // one save at a time: a double click must not delete the next row too
  const pos = useStore($playerPos);
  const [adding, setAdding] = useState(false);
  const full = doc.marks.length >= MAX_MARKS;
  const toggle = (key: "estate" | "library") => (e: Event) =>
    void saveCompass(setHidden(doc, key, !(e.target as HTMLInputElement).checked));
  return (
    <section class="compass-section">
      <h3>羅盤標記</h3>
      {!loaded && <p class="hint">羅盤標記暫時無法載入</p>}
      <label><input type="checkbox" checked={!doc.hide.includes("estate")} disabled={!editable} onChange={toggle("estate")} /> 領地</label>
      <label><input type="checkbox" checked={!doc.hide.includes("library")} disabled={!editable} onChange={toggle("library")} /> library</label>
      <ul class="compass-list">
        {doc.marks.map((m) => (
          <li key={m.id}>
            {m.name} · {Math.round(Math.hypot(m.pos[0] - pos.x, m.pos[1] - pos.z))} m{" "}
            <button class="secondary" disabled={!editable} onClick={() => void saveCompass(removeMark(doc, m.id))}>刪除</button>
          </li>
        ))}
      </ul>
      {adding
        ? <AddMarkForm defaultName={nextMarkName(doc)} pos={[pos.x, pos.z]} onDone={() => setAdding(false)} />
        : <button class="secondary" disabled={!editable || full} onClick={() => setAdding(true)}>標記目前位置</button>}
      {full && <p class="hint">最多 20 個</p>}
    </section>
  );
}
